import Lockr from 'lockr';
import * as types from '../mutation-types';
import { requestLogin, switchTenant } from '@/api';
import router from '../../router';

const user = {
  state: {
    loginName: '',
    permCodes: [],
    headimgurl: '',
    tenantName: '',
    tenants: []
  },
  mutations: {
    // 载入用户信息
    [types.LOAD_USER]: state => {
      const user = Lockr.get('$state') || {};
      state.loginName = user.loginName;
      state.tenantName = user.tenantName;
      state.tenants = user.tenants;
      state.permCodes = user.permCodes || [];
      state.headimgurl = user.headimgurl;
    },
    // 登录
    [types.LOGIN](state, user) {
      Lockr.set('$state', user);
      state.loginName = user.loginName;
      state.tenantName = user.tenantName;
      state.tenants = user.tenants;
      state.permCodes = user.permCodes || [];
      state.headimgurl = user.headimgurl;
    },
    // 注销
    [types.LOGOUT](state) {
      Lockr.rm('$state');
      state.nickName = '';
      state.permCodes = [];
      state.loginName = '';
      state.tenantName = '';
      state.tenants = [];
    },
    // 切换tenant
    [types.SWITCH_TENANT](state, res) {
      const user = Lockr.get('$state') || {};
      user.permCodes = res.obj.permCodes;
      user.tenantName = res.obj.tenantName;
      Lockr.set('$state', user);
      state.permCodes = res.obj.permCodes || [];
      state.tenantName = res.obj.tenantName || '';
      // TODO 跳转到DashBoard，目前为了防止报错，跳转到空白页
      router.push({ name: 'Dashboard' });
    }
  },

  actions: {
    // 用户登录
    login({ commit }, loginParams) {
      return requestLogin(loginParams).then(res => {
        commit(types.LOGIN, res.obj);
      });
    },
    // 切换tenant
    switchTenant({ commit }, params) {
      return switchTenant(params).then(res => {
        console.log(res);
        commit(types.SWITCH_TENANT, res);
      });
    }
  }
};

export default user;
